export default "__VITE_ASSET__bp5XZ0Fv__"